export const skinCustom = {
  lightComponents: {
    body: '#ECEFF1',
    gradient: {
      gradientDefault1: '#ff7714',
      gradientDefault2: '#000000',
    },
  },
  darkComponents: {
    body: '#263238',
    gradient: {
      gradientDefault1: '#172260',
      gradientDefault2: '#000000',
    },
  },
}

export const image = {
  principal: 'https://certificadodigitalacicla.com.br/image-bank/LogoPadrao.png',
  favicon: '/cadeadosd.png',
}

export const seo = {
  titulo: 'Certificado ACICLA',
  email: 'gerencia@acicla.com.br',
  palavrasChave:
    'Certificado Digital, Cnpj a1, Cpf a1, emitir certificado, certificado campo largo',
  descricao:
    'Empresa líder em Certificação Digital, oferecendo soluções seguras e confiáveis para empresas e indivíduos, com ampla experiência no mercado.',
  descricaoPWA:
    'Certificados digitais são identidades eletrônicas seguras usadas para autenticar usuários, proteger informações e realizar transações online com segurança.',
}

export const header = {
  empresa: false,
  solucoes: false,
  contato: true,
  trabalheConosco: false,
  duvidasSuporte: true,
  parcerias: false,
  darkMode: false,
  contaLogin: true,
}

export const escolhaAtendimento = {
  linkagenda: 'https://agenda.certificadodigitalacicla.com.br/',
}

export const contentHome = {
  sispass: true,
  produtorRural: true,
  modalidadesCertificado: true,
  sdConsulta: false,
}

export const footer = {
  is0800: false,
  telefone: '41 3392-4544',
  whatsapp: '41 3032-9674',
  botaoRenocao: '4130329674',
  comercial: '4130329674',
  botaoWhatsapp: '4130329674',
  number0800: '0800 600 2710',
  cidadeuf: 'Campo Largo/PR',
  cidade: 'Campo Largo',
  bairro: 'Centro',
  titulo: 'Certificado Digital em Campo Largo',
  rua: 'Rua Marechal Deodoro',
  numero: '957',
  complemento: '',
  cep: '83601-020',
  cnpj: '79.547.873/0001-79',
  messageContador: 'Olá, tenho interesse em ser Parceiro Indicador.',
  messageRevenda: 'Olá, tenho interesse em revender Certificados Digitais',
  messageAgendamento: 'Olá, gostaria de agendar a emissão do meu Certificado',
  messageRenovacao: 'Olá, gostaria de renovar meu Certificado Digital',
  messageRenovacaoSispass:
    'Olá, gostaria de renovar meu Certificado Digital Sispass',
  messageConhecaNossasSolucoes:
    'Olá, gostaria de conhecer as soluções da Acicla',
}

export const redes = {
  facebook: '',
  instagram: '',
  linkedin: '',
}

export const digisac = {
  id: 'df7a6a14-269a-46ba-a874-33c45e74badf',
  status: false,
}

export const ratings = [
  {
    id: 1,
    descricao: 'Suporte e Atendimento excelentes!',
    author: 'Leonardo Lopes',
    ratingvalue: 5,
  },
  {
    id: 2,
    descricao:
      'Atendimento excelente. Super ágil, prático e simplificado! Ótima organização da equipe.',
    author: 'Tháliton Morais',
    ratingvalue: 5,
  },
  {
    id: 3,
    descricao: 'Atendimento do Suporte Técnico nota 10!.',
    author: 'Felipe Mourão',
    ratingvalue: 5,
  },
]
